module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1ae960cf97d617010f8.worker.js");
};